<template>
  <div class="task-delivery-audit-content">
    <el-form :inline="true" :model="searchCondition" class="search-form">
      <el-form-item label="订单标题">
        <el-input v-model="searchCondition.title" placeholder="请输入订单标题" clearable></el-input>
      </el-form-item>
      <el-form-item label="短剧类型">
        <el-select v-model="searchCondition.category_type" placeholder="全部" clearable>
          <el-option v-for="item in categoryOptions" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="交付状态">
        <el-select v-model="searchCondition.deliver_status" placeholder="全部" clearable>
          <el-option v-for="item in deliverStatusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="searchCondition.fullname" placeholder="请输入姓名" clearable></el-input>
      </el-form-item>
      <el-form-item label="联系方式">
        <el-input v-model="searchCondition.join_mobile" placeholder="请输入联系方式" clearable></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <DatePicker :value="dateRange" @dataSearch="dataSearch" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchButton">查询</el-button>
        <el-button @click="resetSearch">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" :data="tableData" style="width: 100%" :header-cell-style="{ background: '#fbfbfb' }">
      <el-table-column prop="title" label="订单标题" min-width="150" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="category_type" label="短剧类型" width="120" align="center"></el-table-column>
      <el-table-column prop="creator_fullname" label="发布者" width="120" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column label="时间" width="220" align="center">
        <template slot-scope="scope">
          <div>{{ scope.row.order_start_time || '-' }}</div>
          <div>至 {{ scope.row.order_end_time || '-' }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="fullname" label="姓名" width="100" align="center" show-overflow-tooltip></el-table-column>
      <el-table-column prop="join_mobile" label="联系电话" width="130" align="center"></el-table-column>
      <el-table-column prop="salary_range" label="薪酬范围" width="150" align="center"></el-table-column>
      <el-table-column label="状态" width="110" align="center">
        <template slot-scope="scope">
          <el-tag :type="deliverTagType(scope.row.deliver_status)">{{ deliverStatusText(scope.row.deliver_status, scope.row.status_text) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="260" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" @click="openDetail(scope.row)">查看</el-button>
          <el-button v-if="scope.row.deliver_status == 1" size="mini" type="primary" @click="openAuditDetail(scope.row)">审核</el-button>
          <el-button v-if="scope.row.deliver_status == 1" size="mini" type="text" @click="openEdit(scope.row)">编辑</el-button>
          <el-button v-if="scope.row.deliver_status == 3" size="mini" type="text" @click="openRejectInfo(scope.row)">驳回原因</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="pagination"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="page.current_page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="page.page_size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
    ></el-pagination>

    <el-dialog :title="detailAuditMode ? '交付审核' : '交付详情'" :visible.sync="detailVisible" width="960px" top="6vh">
      <div v-loading="detailLoading" class="detail-wrapper">
        <div class="preview-panel">
          <div class="media-preview">
            <img v-if="currentPreview && currentPreview.file_type == 'image'" :src="currentPreview.url" />
            <video v-else-if="currentPreview && currentPreview.file_type == 'video'" :src="currentPreview.url" controls></video>
            <div v-else class="empty-preview">暂无图片或视频预览</div>
          </div>
          <div v-if="previewFiles.length > 1" class="preview-switch">
            <span
              v-for="(item, index) in previewFiles"
              :key="item.url + index"
              :class="{ active: index === previewIndex }"
              @click="previewIndex = index"
            ></span>
          </div>
          <div class="file-list">
            <div class="file-list-title">文件清单</div>
            <div v-if="detailFiles.length">
              <div v-for="(file, index) in detailFiles" :key="file.url + index" class="file-item">
                <span class="file-name">{{ file.name || file.url }}</span>
                <div class="file-actions">
                  <el-button v-if="canPreviewFile(file)" type="text" size="mini" @click="previewOrDownload(file)">查看</el-button>
                  <el-button type="text" size="mini" @click="downloadFile(file)">下载</el-button>
                </div>
              </div>
            </div>
            <div v-else class="empty-file">暂无文件</div>
          </div>
        </div>
        <div class="order-info">
          <h3>订单详情</h3>
          <p><span>订单描述：</span>{{ detailData.description || '-' }}</p>
          <p><span>标题：</span>{{ detailData.title || '-' }}</p>
          <p><span>短剧类型：</span>{{ detailData.category_type || '-' }}</p>
          <p><span>薪酬范围：</span>{{ detailData.salary_range || '-' }}</p>
          <p><span>制作周期：</span>{{ detailData.production_cycle || '-' }}</p>
          <p><span>订单开始时间：</span>{{ detailData.order_start_time || '-' }}</p>
          <p><span>订单结束时间：</span>{{ detailData.order_end_time || '-' }}</p>
          <p><span>报名人：</span>{{ detailData.fullname || '-' }}</p>
          <p><span>联系方式：</span>{{ detailData.join_mobile || '-' }}</p>
          <p><span>交付说明：</span>{{ detailData.deliver_content || '-' }}</p>
          <div v-if="detailAuditMode && detailData.deliver_status == 1" class="detail-actions">
            <el-button type="primary" @click="openConfirm(detailData, 2)">审核通过</el-button>
            <el-button type="danger" @click="openConfirm(detailData, 3)">审核不通过</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="confirmTitle" :visible.sync="confirmVisible" width="520px">
      <div v-if="confirmForm.deliver_status == 2" class="confirm-text">是否确认审核通过？</div>
      <el-form v-else :model="confirmForm" label-width="90px">
        <el-form-item label="驳回原因" required>
          <el-input v-model="confirmForm.deliver_message" type="textarea" placeholder="请输入驳回原因" maxlength="100" show-word-limit :rows="4"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="confirmVisible = false">取 消</el-button>
        <el-button type="primary" :loading="auditSubmitting" @click="submitAudit">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="交付编辑" :visible.sync="editVisible" width="960px" top="6vh">
      <div v-loading="editLoading" class="detail-wrapper">
        <div class="preview-panel">
          <div class="media-preview">
            <img v-if="editCurrentPreview && editCurrentPreview.file_type == 'image'" :src="editCurrentPreview.url" />
            <video v-else-if="editCurrentPreview && editCurrentPreview.file_type == 'video'" :src="editCurrentPreview.url" controls></video>
            <div v-else class="empty-preview">暂无图片或视频预览</div>
          </div>
          <div v-if="editPreviewFiles.length > 1" class="preview-switch">
            <span
              v-for="(item, index) in editPreviewFiles"
              :key="item.url + index"
              :class="{ active: index === editPreviewIndex }"
              @click="editPreviewIndex = index"
            ></span>
          </div>
          <div class="file-list edit-file-list">
            <div class="file-list-title">文件清单</div>
            <DeferredOssUploader
              ref="deliveryUploader"
              v-model="editFileList"
              dir="bill"
              :limit="20"
              tip="支持图片、视频、压缩包及常见文档，最多上传20份。"
              @preview="previewEditFile"
              @download="downloadFile"
            ></DeferredOssUploader>
          </div>
        </div>
        <div class="order-info">
          <h3>订单详情</h3>
          <p><span>订单描述：</span>{{ editDetail.description || '-' }}</p>
          <p><span>标题：</span>{{ editDetail.title || '-' }}</p>
          <p><span>短剧类型：</span>{{ editDetail.category_type || '-' }}</p>
          <p><span>薪酬范围：</span>{{ editDetail.salary_range || '-' }}</p>
          <p><span>制作周期：</span>{{ editDetail.production_cycle || '-' }}</p>
          <p><span>订单开始时间：</span>{{ editDetail.order_start_time || '-' }}</p>
          <p><span>订单结束时间：</span>{{ editDetail.order_end_time || '-' }}</p>
          <p><span>报名人：</span>{{ editDetail.fullname || '-' }}</p>
          <p><span>联系方式：</span>{{ editDetail.join_mobile || '-' }}</p>
          <div class="deliver-content-edit">
            <div class="deliver-content-label">交付说明：</div>
            <el-input v-model="editForm.deliver_content" type="textarea" placeholder="请输入交付说明" :rows="5" maxlength="500" show-word-limit></el-input>
          </div>
          <div class="detail-actions edit-actions">
            <el-button @click="editVisible = false">取 消</el-button>
            <el-button type="primary" :loading="editSubmitting" @click="confirmSubmitEdit">确 认</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="驳回原因" :visible.sync="rejectVisible" width="480px">
      <div v-loading="rejectLoading" class="reject-info">
        <p>{{ rejectInfo.deliver_message || '-' }}</p>
        <div>审核人：{{ rejectInfo.auditor_fullname || '-' }}</div>
        <div>审核时间：{{ rejectInfo.deliver_audit_at || '-' }}</div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="rejectVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import DatePicker from '@/components/DatePicker.vue'
import DeferredOssUploader from '@/components/DeferredOssUploader'

export default {
  name: 'KhlTaskDeliveryAuditContent',
  components: {
    DatePicker,
    DeferredOssUploader
  },
  data() {
    return {
      loading: false,
      detailLoading: false,
      editLoading: false,
      auditSubmitting: false,
      editSubmitting: false,
      rejectLoading: false,
      tableData: [],
      dateRange: [],
      searchCondition: {},
      page: {
        current_page: 1,
        page_size: 10,
        total: 0
      },
      categoryOptions: ['都市', '悬疑推理', '古装仙侠', '霸总甜宠', '科幻', '校园青春', '品牌公益宣传片', 'AI漫剧', '古装穿越', '少儿高梦', '真人写实', '少儿科普剧', '简单类型', '其他'],
      deliverStatusOptions: [
        { label: '未交付', value: 0 },
        { label: '待审核', value: 1 },
        { label: '交付通过', value: 2 },
        { label: '交付未通过', value: 3 }
      ],
      detailVisible: false,
      detailAuditMode: false,
      detailData: {},
      previewIndex: 0,
      confirmVisible: false,
      confirmForm: {
        id: '',
        deliver_status: 2,
        deliver_message: ''
      },
      editVisible: false,
      editDetail: {},
      editForm: {
        id: '',
        deliver_content: ''
      },
      editFileList: [],
      editPreviewIndex: 0,
      rejectVisible: false,
      rejectInfo: {}
    }
  },
  computed: {
    detailFiles() {
      return this.normalizeFiles(this.detailData.deliver_files_list || [])
    },
    previewFiles() {
      return this.detailFiles.filter(item => item.file_type === 'image' || item.file_type === 'video')
    },
    currentPreview() {
      return this.previewFiles[this.previewIndex]
    },
    editFiles() {
      return this.normalizeFiles(this.editFileList)
    },
    editPreviewFiles() {
      return this.editFiles.filter(item => item.file_type === 'image' || item.file_type === 'video')
    },
    editCurrentPreview() {
      return this.editPreviewFiles[this.editPreviewIndex]
    },
    confirmTitle() {
      return this.confirmForm.deliver_status == 2 ? '审核通过确认' : '审核不通过确认'
    }
  },
  created() {
    this.init()
  },
  methods: {
    searchButton() {
      this.page.current_page = 1
      this.init()
    },
    resetSearch() {
      this.searchCondition = {}
      this.dateRange = []
      this.searchButton()
    },
    dataSearch(value) {
      this.dateRange = value || []
      if (this.dateRange.length) {
        this.searchCondition.start_time = this.dateRange[0]
        this.searchCondition.end_time = this.dateRange[1]
      } else {
        delete this.searchCondition.start_time
        delete this.searchCondition.end_time
      }
    },
    handleSizeChange(val) {
      this.page.page_size = val
      this.page.current_page = 1
      this.init()
    },
    handleCurrentChange(val) {
      this.page.current_page = val
      this.init()
    },
    handleSearchCondition() {
      let condition = {}
      ;['title', 'category_type', 'fullname', 'join_mobile', 'start_time', 'end_time'].forEach(key => {
        if (this.searchCondition[key]) {
          condition[key] = this.searchCondition[key]
        }
      })
      if (this.searchCondition.deliver_status === 0 || this.searchCondition.deliver_status) {
        condition.deliver_status = this.searchCondition.deliver_status
      }
      return condition
    },
    async init() {
      this.loading = true
      let params = Object.assign({}, this.handleSearchCondition(), {
        current_page: this.page.current_page,
        page_size: this.page.page_size
      })
      try {
        let res = await this.$api.getKhlAiOrderDeliverList(params)
        this.tableData = res.data || []
        this.page = Object.assign({}, this.page, res.pages || {})
      } finally {
        this.loading = false
      }
    },
    async openDetail(row) {
      this.detailAuditMode = false
      this.detailVisible = true
      this.detailLoading = true
      this.previewIndex = 0
      try {
        this.detailData = await this.$api.getKhlAiOrderDeliverInfo({ id: row.id }) || {}
      } finally {
        this.detailLoading = false
      }
    },
    async openAuditDetail(row) {
      this.detailAuditMode = true
      this.detailVisible = true
      this.detailLoading = true
      this.previewIndex = 0
      try {
        this.detailData = await this.$api.getKhlAiOrderDeliverInfo({ id: row.id }) || {}
      } finally {
        this.detailLoading = false
      }
    },
    openConfirm(row, status) {
      this.confirmForm = {
        id: row.id,
        deliver_status: status,
        deliver_message: ''
      }
      this.confirmVisible = true
    },
    async submitAudit() {
      if (this.confirmForm.deliver_status == 3 && !this.confirmForm.deliver_message) {
        this.$message.error('请输入驳回原因')
        return
      }
      let params = {
        id: this.confirmForm.id,
        deliver_status: this.confirmForm.deliver_status
      }
      if (this.confirmForm.deliver_status == 3) {
        params.deliver_message = this.confirmForm.deliver_message
      }
      this.auditSubmitting = true
      try {
        let result = await this.$api.auditKhlAiOrderDeliver(params)
        if (result) {
          this.$message.success('审核成功')
          this.confirmVisible = false
          this.detailVisible = false
          this.init()
        } else {
          this.$message.warning('未更新审核状态')
        }
      } finally {
        this.auditSubmitting = false
      }
    },
    async openEdit(row) {
      if (row.deliver_status != 1) {
        this.$message.error('只有未审核状态可以编辑')
        return
      }
      this.editVisible = true
      this.editLoading = true
      this.editPreviewIndex = 0
      try {
        let info = await this.$api.getKhlAiOrderDeliverInfo({ id: row.id }) || {}
        this.editDetail = info
        this.editForm = {
          id: info.id,
          deliver_content: info.deliver_content || ''
        }
        this.editFileList = this.normalizeFiles(info.deliver_files_list || [])
      } finally {
        this.editLoading = false
      }
    },
    confirmSubmitEdit() {
      this.$confirm('是否确认保存本次交付编辑？', '确认保存', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        this.submitEdit()
      }).catch(() => {})
    },
    async submitEdit() {
      if (!this.editForm.deliver_content && !this.editFileList.length) {
        this.$message.error('请填写交付内容或上传交付文件')
        return
      }
      this.editSubmitting = true
      try {
        let uploadedFiles = this.$refs.deliveryUploader ? await this.$refs.deliveryUploader.upload() : this.editFiles
        this.editFileList = uploadedFiles
        let deliverFiles = uploadedFiles.map(item => ({
          url: item.url,
          name: item.name || this.getFileName(item.url)
        })).filter(item => item.url)
        let result = await this.$api.updateKhlAiOrderDeliver({
          id: this.editForm.id,
          deliver_content: this.editForm.deliver_content,
          deliver_files: deliverFiles
        })
        if (result) {
          this.$message.success('保存成功')
          this.editVisible = false
          this.init()
        } else {
          this.$message.warning('未更新交付内容')
        }
      } catch (error) {
        this.$message.error(error && error.message ? error.message : '保存失败')
      } finally {
        this.editSubmitting = false
      }
    },
    async openRejectInfo(row) {
      this.rejectVisible = true
      this.rejectLoading = true
      try {
        this.rejectInfo = await this.$api.getKhlAiOrderDeliverRejectInfo({ id: row.id }) || {}
      } finally {
        this.rejectLoading = false
      }
    },
    previewEditFile(file) {
      if (!this.canPreviewFile(file)) {
        return
      }
      this.previewOrDownload(file, this.editPreviewFiles, true)
    },
    canPreviewFile(file) {
      return file && (file.file_type === 'image' || file.file_type === 'video')
    },
    previewOrDownload(file, previewFiles, updateEditPreview) {
      let fileUrl = file && (file.url || file.local_url)
      if (!fileUrl) {
        return
      }
      let files = previewFiles || this.previewFiles
      let index = files.findIndex(item => (item.url || item.local_url) === fileUrl)
      if (index > -1) {
        if (updateEditPreview) {
          this.editPreviewIndex = index
        } else {
          this.previewIndex = index
        }
        return
      }
      window.open(fileUrl, '_blank')
    },
    async downloadFile(file) {
      if (!file || !file.url) {
        return
      }
      let fileName = file.name || this.getFileName(file.url)
      try {
        let response = await fetch(file.url)
        if (!response.ok) {
          throw new Error('download failed')
        }
        let blob = await response.blob()
        let blobUrl = URL.createObjectURL(blob)
        this.triggerDownload(blobUrl, fileName)
        URL.revokeObjectURL(blobUrl)
      } catch (error) {
        this.triggerDownload(file.url, fileName, true)
      }
    },
    triggerDownload(url, fileName, openFallback) {
      let link = document.createElement('a')
      link.href = url
      if (openFallback) {
        link.target = '_blank'
      }
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    normalizeFiles(files) {
      if (!Array.isArray(files)) {
        return []
      }
      return files.map(item => {
        let url = typeof item === 'string' ? item : (item.url || item.full_path || item.path || item.local_url || '')
        let name = typeof item === 'string' ? this.getFileName(item) : (item.name || item.title || this.getFileName(url))
        return Object.assign({}, typeof item === 'string' ? {} : item, {
          url,
          name,
          file_type: (typeof item === 'string' ? '' : item.file_type) || this.getFileType(name || url)
        })
      }).filter(item => item.url)
    },
    resolvePreviewIndex(files, index) {
      if (!files.length) {
        return 0
      }
      return index >= files.length ? files.length - 1 : index
    },
    getFileName(url) {
      if (!url) {
        return ''
      }
      return String(url).split('?')[0].split('/').pop()
    },
    getFileType(name) {
      let extension = String(name || '').split('?')[0].split('.').pop().toLowerCase()
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].indexOf(extension) > -1) {
        return 'image'
      }
      if (['mp4', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'webm'].indexOf(extension) > -1) {
        return 'video'
      }
      if (['zip', 'rar', '7z', 'tar', 'gz'].indexOf(extension) > -1) {
        return 'archive'
      }
      return 'file'
    },
    deliverStatusText(status, statusText) {
      let item = this.deliverStatusOptions.find(option => option.value == status)
      return statusText || (item ? item.label : '-')
    },
    deliverTagType(status) {
      if (status == 2) {
        return 'success'
      }
      if (status == 3) {
        return 'danger'
      }
      if (status == 1) {
        return 'warning'
      }
      return 'info'
    }
  }
}
</script>

<style scoped lang="scss">
.task-delivery-audit-content {
  background: #fff;
  padding-bottom: 60px;
}

.search-form {
  margin-bottom: 12px;
}

.pagination {
  float: right;
  margin-top: 20px;
}

.detail-wrapper {
  display: flex;
  gap: 24px;
}

.preview-panel {
  width: 560px;
}

.media-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 320px;
  background: #f5f7fa;
}

.media-preview img,
.media-preview video {
  max-width: 100%;
  max-height: 100%;
}

.empty-preview,
.empty-file {
  color: #909399;
}

.preview-switch {
  margin: 12px 0;
  text-align: center;
}

.preview-switch span {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin: 0 5px;
  border: 1px solid #c0c4cc;
  border-radius: 50%;
  cursor: pointer;
}

.preview-switch span.active {
  background: #409eff;
  border-color: #409eff;
}

.file-list {
  min-height: 150px;
  padding: 12px;
  background: #fafafa;
}

.file-list-title {
  margin-bottom: 8px;
  font-weight: bold;
}

.file-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  line-height: 28px;
}

.file-name {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.edit-file-list {
  max-height: 220px;
  overflow-y: auto;
}

.file-actions {
  flex-shrink: 0;
  margin-left: 12px;
}

.file-actions .el-button + .el-button {
  margin-left: 6px;
}

.order-info {
  flex: 1;
}

.order-info h3 {
  margin: 0 0 16px;
}

.order-info p {
  margin: 0 0 8px;
  line-height: 22px;
  word-break: break-all;
}

.order-info span {
  color: #606266;
  font-weight: bold;
}

.detail-actions {
  margin-top: 40px;
}

.detail-actions .el-button {
  width: 160px;
  margin-bottom: 12px;
  display: block;
}

.detail-actions .el-button + .el-button {
  margin-left: 0;
}

.edit-actions {
  display: flex;
  margin-top: 24px;
}

.edit-actions .el-button {
  display: inline-block;
  width: 120px;
  margin-bottom: 0;
}

.edit-actions .el-button + .el-button {
  margin-left: 12px;
}

.deliver-content-edit {
  margin-top: 16px;
}

.deliver-content-label {
  margin-bottom: 8px;
  color: #606266;
  font-weight: bold;
}

.confirm-text {
  line-height: 80px;
  text-align: center;
}

.reject-info {
  line-height: 24px;
}

.upload-tip {
  margin-top: 8px;
  color: #909399;
  font-size: 12px;
  line-height: 18px;
}
</style>
